import React, { useEffect, useState, useCallback } from 'react';
import api from '../api';
import { CLIENT_URL } from '../config';
import { useAdminLanguage } from '../AdminLanguageContext';
import useAdminDialog from '../components/AdminDialog';

export default function Posts() {
  const { copy } = useAdminLanguage();
  const postsCopy = copy.posts;
  const [data, setData] = useState({ posts: [], total: 0 });
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const { confirmAction, dialog } = useAdminDialog();

  const fetch = useCallback(() => {
    setLoading(true);
    api.get('/admin/posts', { params: { keyword, page, limit: 20 } })
      .then(res => setData(res.data))
      .finally(() => setLoading(false));
  }, [keyword, page]);

  useEffect(() => { fetch(); }, [fetch]);

  const handlePin = async (id, pinned) => {
    await api.put(`/admin/posts/${id}/pin`);
    fetch();
  };

  const handleDelete = async (id) => {
    if (!await confirmAction({
      title: postsCopy.deleteConfirm.title,
      message: postsCopy.deleteConfirm.message,
      variant: 'danger',
    })) return;
    await api.delete(`/admin/posts/${id}`);
    fetch();
  };

  return (
    <div>
      {dialog}
      <div className="page-title">{postsCopy.title}</div>
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <div className="search-input" style={{ margin: 0 }}>
            <input placeholder={postsCopy.searchPlaceholder} value={keyword}
              onChange={e => { setKeyword(e.target.value); setPage(1); }} />
          </div>
          <span style={{ fontSize: 13, color: '#6b7280', alignSelf: 'center' }}>{postsCopy.total(data.total)}</span>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>{postsCopy.columns.id}</th><th>{postsCopy.columns.title}</th><th>{postsCopy.columns.category}</th><th>{postsCopy.columns.author}</th>
                <th>{postsCopy.columns.views}</th><th>{postsCopy.columns.replies}</th><th>{postsCopy.columns.pinned}</th><th>{postsCopy.columns.createdAt}</th><th>{postsCopy.columns.actions}</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={9} style={{ textAlign: 'center', color: '#9ca3af', padding: 32 }}>{postsCopy.loading}</td></tr>
              ) : data.posts.map(p => (
                <tr key={p.id}>
                  <td>{p.id}</td>
                  <td style={{ maxWidth: 220, fontWeight: 500 }}>
                    <a href={`${CLIENT_URL}/forum/posts/${p.id}`} target="_blank" rel="noreferrer"
                      style={{ color: '#4154f1' }}>{p.title}</a>
                  </td>
                  <td><span className="badge badge-blue">{p.category_name}</span></td>
                  <td style={{ color: '#6b7280' }}>{p.author_name}</td>
                  <td>{p.view_count}</td>
                  <td>{p.reply_count}</td>
                  <td>
                    {p.is_pinned ? <span className="badge badge-orange">{postsCopy.pinnedBadge}</span> : '-'}
                  </td>
                  <td style={{ color: '#6b7280' }}>{new Date(p.created_at).toLocaleDateString()}</td>
                  <td>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-sm btn-outline" onClick={() => handlePin(p.id, p.is_pinned)}>
                        {p.is_pinned ? postsCopy.actions.unpin : postsCopy.actions.pin}
                      </button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(p.id)}>{postsCopy.actions.delete}</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="pagination">
          <button className="btn btn-sm btn-outline" disabled={page === 1} onClick={() => setPage(p => p - 1)}>{postsCopy.previous}</button>
          <span>{postsCopy.page(page)}</span>
          <button className="btn btn-sm btn-outline" disabled={page * 20 >= data.total} onClick={() => setPage(p => p + 1)}>{postsCopy.next}</button>
        </div>
      </div>
    </div>
  );
}
